import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'

import { Container, Image, Spinner, Button } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      products: [],
      count: 0,
      sum: 0,
      sort: true,
      sortName: `Сначала дешевле`
    }
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '') return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  normalize_count_form = (number, words_arr) => {
    number = Math.abs(number)
    if (Number.isInteger(number)) {
      let options = [2, 0, 1, 1, 1, 2]
      return words_arr[(number % 100 > 4 && number % 100 < 20) ? 2 : options[(number % 10 < 5) ? number % 10 : 5]]
    }
    return words_arr[1]
  }

  getCart() {
    const { cart, addTocart } = this.props

    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'get_cart_data',
      'cart': JSON.stringify( cart )
    }).then( ( response ) => {
      var fined = false
      cart.map( ( product ) => {
        fined = false
        response.data.products.map( ( in_cart ) => {
          if( product.variant == null ) {
            if( product.product == in_cart.product ) {
              if( in_cart.stocks < product.count ) {
                addTocart({
                  resource: product.resource,
                  product: product.product,
                  variant: null,
                  count: in_cart.stocks
                })
              }
              fined = true
            }
          } else {
            if( product.product == in_cart.product && product.variant == in_cart.variant ) {
              if( in_cart.stocks < product.count ) {
                addTocart({
                  resource: product.resource,
                  product: product.product,
                  variant: product.variant,
                  count: in_cart.stocks
                })
              }
              fined = true
            }
          }
        } )
        if( !fined ) {
          addTocart({
            resource: product.resource,
            product: product.product,
            variant: product.variant,
            count: 0
          })
        }
      } )
      this.setState({
        loaded: true,
        products: response.data.products,
        count: response.data.count,
        sum: response.data.sum
      })
    })
  }

  changeCount = ( product, count ) => {
    const { addTocart } = this.props,
    main = this

    addTocart({
      resource: product.res_id,
      product: product.product,
      variant: product.variant,
      count: count
    }, () => {
      main.getCart()
    })
  }

  changeSort() {
    const { sort } = this.state

    this.setState({
      sort: !sort,
      sortName: sort ? `Сначала дороже` : `Сначала дешевле`
    })
  }

  componentDidMount() {
    this.getCart()
  }

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, favorite, cart, changeFavorite } = this.props,
    { loaded, products, count, sum, sort, sortName } = this.state

    if(ajax_data != null) return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          <HeaderPage
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={changeTopSearch}
            changeLeftMenuh={changeLeftMenuh}
            favorite={favorite}
            cart={cart}
          />
          {ajax_data != null &&
            <>
              <Breadcrumbs
                pages={[
                  {
                    name: ajax_data.pagetitle,
                    current: true
                  }
                ]}
              />
              <div className={styles.korzina}>
                <Container>
                  <div className='d-flex flex-column flex-xl-row align-items-start justify-content-between'>
                    <div className={styles.korzina_flex}>
                      <div className="d-flex align-items-center justify-content-between">
                        <h1>{ajax_data.seo_h1}</h1>
                        <div onClick={() => this.changeSort()} className={styles.korzina_sort}>
                          <div>{sortName}</div>
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 12L4 15M4 15L1 12M4 15V1M9 4L12 1M12 1L15 4M12 1V15" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      {loaded ?
                        <>
                          {products.length > 0 ?
                            <div className={styles.korzina_list}>
                              {products.sort((a, b) =>
                                a.price > b.price == sort ? 1 : -1,
                              ).map( ( product, k ) => {
                                return (
                                  <div className={styles.korzina_list_elm} key={k}>
                                    <div style={{ flex: 1 }} className='d-flex'>
                                      {product.image != null &&
                                        <a href={product.url}>
                                          <Image className={styles.korzina_list_elm_image} src={product.image} width="117" height="172" />
                                        </a>
                                      }
                                      <div className={styles.korzina_list_elm_content}>
                                        <div className={styles.korzina_list_elm_art}>Арт. {product.article}</div>
                                        <div className={styles.korzina_list_elm_name}>{product.name}</div>
                                        {product.size && <div className={styles.korzina_list_elm_option}>Размер: {product.size}</div>}
                                        {product.colorName && <div className={styles.korzina_list_elm_option_color}>
                                          Цвет: {product.colorName}
                                          <div className={styles.korzina_list_elm_option_color_dot}></div>
                                          <div style={{ backgroundColor: product.color }} className={styles.korzina_list_elm_option_color_color}></div>
                                        </div>}
                                        <div style={{ flex: 1 }} className='d-flex flex-column d-sm-none w-100'>
                                          <div className={styles.korzina_list_elm_price}>{this.priceFormat(product.price)} ₽</div>
                                          <div className='d-block' style={{ flex: 1 }}></div>
                                          <div className='d-flex align-items-end justify-content-between w-100'>
                                            <div className={styles.korzina_list_elm_btns + ` d-flex`}>
                                              <svg onClick={() => changeFavorite( product.res_id )} width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0 3.2002V12.6854C0 14.0464 0 14.7268 0.204119 15.1433C0.582446 15.9151 1.41157 16.3588 2.26367 16.2454C2.7234 16.1842 3.28964 15.8067 4.4221 15.0518L4.42481 15.0499C4.87368 14.7507 5.09815 14.6011 5.33295 14.5181C5.76421 14.3656 6.23476 14.3656 6.66602 14.5181C6.90129 14.6012 7.12664 14.7515 7.57732 15.0519C8.70978 15.8069 9.27665 16.1841 9.73638 16.2452C10.5885 16.3586 11.4176 15.9151 11.7959 15.1433C12 14.7269 12 14.0462 12 12.6854V3.19691C12 2.07899 12 1.5192 11.7822 1.0918C11.5905 0.715473 11.2837 0.409734 10.9074 0.217987C10.4796 0 9.9203 0 8.8002 0H3.2002C2.08009 0 1.51962 0 1.0918 0.217987C0.715473 0.409734 0.409734 0.715473 0.217987 1.0918C0 1.51962 0 2.08009 0 3.2002Z" fill={favorite.includes( product.res_id ) ? `#FF0000` : `#F6F6F6`}/>
                                              </svg>
                                              <svg onClick={() => this.changeCount( product, 0 )} width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 4V15.8C3 16.9201 3 17.4798 3.21799 17.9076C3.40973 18.2839 3.71547 18.5905 4.0918 18.7822C4.5192 19 5.07899 19 6.19691 19H11.8031C12.921 19 13.48 19 13.9074 18.7822C14.2837 18.5905 14.5905 18.2839 14.7822 17.9076C15 17.4802 15 16.921 15 15.8031V4M3 4H5M3 4H1M5 4H13M5 4C5 3.06812 5 2.60241 5.15224 2.23486C5.35523 1.74481 5.74432 1.35523 6.23438 1.15224C6.60192 1 7.06812 1 8 1H10C10.9319 1 11.3978 1 11.7654 1.15224C12.2554 1.35523 12.6447 1.74481 12.8477 2.23486C12.9999 2.6024 13 3.06812 13 4M13 4H15M15 4H17" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                              </svg>
                                            </div>
                                            {product.article !== 16162 && product.article !== 16163 && (
                                              <div className={styles.korzina_list_elm_count}>
                                                <svg onClick={() => this.changeCount( product, product.count > 1 ? product.count - 1 : 1 )} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect x="0.375" y="0.375" width="29.25" height="29.25" rx="14.625" stroke="black" strokeWidth="0.75"/>
                                                  <path d="M7 15L23 15" stroke="black" strokeWidth="0.75"/>
                                                </svg>
                                                <div>{product.count}</div>
                                                <svg onClick={() => this.changeCount( product, product.stocks > product.count ? product.count + 1 : product.stocks )} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect x="0.375" y="0.375" width="29.25" height="29.25" rx="14.625" stroke="black" strokeWidth="0.75"/>
                                                  <path d="M15 7V23" stroke="black" strokeWidth="0.75"/>
                                                  <path d="M7 15L23 15" stroke="black" strokeWidth="0.75"/>
                                                </svg>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        <div className='d-none d-sm-block' style={{ flex: 1 }}></div>
                                        <div className={styles.korzina_list_elm_btns + ` d-none d-sm-flex`}>
                                          <svg onClick={() => changeFavorite( product.res_id )} width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 3.2002V12.6854C0 14.0464 0 14.7268 0.204119 15.1433C0.582446 15.9151 1.41157 16.3588 2.26367 16.2454C2.7234 16.1842 3.28964 15.8067 4.4221 15.0518L4.42481 15.0499C4.87368 14.7507 5.09815 14.6011 5.33295 14.5181C5.76421 14.3656 6.23476 14.3656 6.66602 14.5181C6.90129 14.6012 7.12664 14.7515 7.57732 15.0519C8.70978 15.8069 9.27665 16.1841 9.73638 16.2452C10.5885 16.3586 11.4176 15.9151 11.7959 15.1433C12 14.7269 12 14.0462 12 12.6854V3.19691C12 2.07899 12 1.5192 11.7822 1.0918C11.5905 0.715473 11.2837 0.409734 10.9074 0.217987C10.4796 0 9.9203 0 8.8002 0H3.2002C2.08009 0 1.51962 0 1.0918 0.217987C0.715473 0.409734 0.409734 0.715473 0.217987 1.0918C0 1.51962 0 2.08009 0 3.2002Z" fill={favorite.includes( product.res_id ) ? `#FF0000` : `#F6F6F6`}/>
                                          </svg>
                                          <svg onClick={() => this.changeCount( product, 0 )} width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3 4V15.8C3 16.9201 3 17.4798 3.21799 17.9076C3.40973 18.2839 3.71547 18.5905 4.0918 18.7822C4.5192 19 5.07899 19 6.19691 19H11.8031C12.921 19 13.48 19 13.9074 18.7822C14.2837 18.5905 14.5905 18.2839 14.7822 17.9076C15 17.4802 15 16.921 15 15.8031V4M3 4H5M3 4H1M5 4H13M5 4C5 3.06812 5 2.60241 5.15224 2.23486C5.35523 1.74481 5.74432 1.35523 6.23438 1.15224C6.60192 1 7.06812 1 8 1H10C10.9319 1 11.3978 1 11.7654 1.15224C12.2554 1.35523 12.6447 1.74481 12.8477 2.23486C12.9999 2.6024 13 3.06812 13 4M13 4H15M15 4H17" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-none d-sm-flex flex-column align-items-end'>
                                      <div className={styles.korzina_list_elm_price}>{this.priceFormat(product.price)} ₽</div>
                                      <div style={{ flex: 1 }}></div>
                                      {product.article !== 16162 && product.article !== 16163 && (
                                        <div className={styles.korzina_list_elm_count}>
                                          <svg onClick={() => this.changeCount( product, product.count > 1 ? product.count - 1 : 1 )} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.375" y="0.375" width="29.25" height="29.25" rx="14.625" stroke="black" strokeWidth="0.75"/>
                                            <path d="M7 15L23 15" stroke="black" strokeWidth="0.75"/>
                                          </svg>
                                          <div>{product.count}</div>
                                          <svg onClick={() => this.changeCount( product, product.stocks > product.count ? product.count + 1 : product.stocks )} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.375" y="0.375" width="29.25" height="29.25" rx="14.625" stroke="black" strokeWidth="0.75"/>
                                            <path d="M15 7V23" stroke="black" strokeWidth="0.75"/>
                                            <path d="M7 15L23 15" stroke="black" strokeWidth="0.75"/>
                                          </svg>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          :
                            <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                              <p>Добавьте товары в корзину</p>
                            </div>
                          }
                        </>
                      :
                        <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                          <Spinner animation="grow" variant="dark" />
                        </div>
                      }
                    </div>
                    <div className={styles.korzina_rchast}>
                      <div className={styles.korzina_rchast_plashka}>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className={styles.korzina_rchast_title}>ВАШ ЗАКАЗ</div>
                          <div className={styles.korzina_rchast_count}>{count} {this.normalize_count_form( count, [ 'товар', 'товара', 'товаров' ] )}</div>
                        </div>
                        <div className={styles.korzina_rchast_text}>Доступные способы доставки можно выбрать при оформлении заказа</div>
                        <div className={styles.korzina_rchast_sep}></div>
                        {sum > 0 &&
                          <>
                            <div className={styles.korzina_rchast_sum}>
                              <div>Итого:</div>
                              <div>{this.priceFormat(sum)} ₽</div>
                            </div>
                            <Button href={ajax_data.oformlenie_lnk} className={styles.korzina_rchast_btn + ` w-100`} variant='dark'>
                              <div>Оформить заказ</div>
                              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </Button>
                          </>
                        }
                      </div>
                      <div className={styles.korzina_rchast_katalog}>
                        <a href={page_data.new_link}>Вернуться за покупками</a>
                      </div>
                    </div>
                  </div>
                </Container>
              </div>
            </>
          }
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool,
  addTocart: PropTypes.func
}